/**
 * API Cảnh báo – POC dùng mock; triển khai thật dùng cùng endpoint với backend.
 */
import { apiSlice } from './apiSlice'
import type { Alert } from '../../types/alert'

export const alertsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMyAlerts: builder.query<Alert[], void>({
      query: () => ({ url: 'alerts', method: 'GET' }),
      providesTags: ['Alerts'],
    }),
  }),
})

export const { useGetMyAlertsQuery } = alertsApi
